<template>
  <v-container class="py-6" max-width="800px">
    <v-card elevation="3" class="pa-4">
      <!-- Header -->
      <v-row justify="space-between" align="center">
        <v-col cols="auto">
          <h2 class="text-h6 font-weight-bold">Beverage Submission</h2>
        </v-col>
        <v-col cols="auto">
          <v-chip
            :color="getStatusColor(submission?.status)"
            dark
            small
            class="text-capitalize"
          >
            {{ submission?.status || "Unknown" }}
          </v-chip>
        </v-col>
      </v-row>

      <!-- Images -->
      <v-row class="mb-4" dense>
        <v-col cols="12" sm="6">
          <v-img
            :src="submission?.beverageImage"
            aspect-ratio="1"
            class="rounded-lg"
            cover
          >
            <template #placeholder>
              <v-skeleton-loader type="image" />
            </template>
          </v-img>
          <div class="text-caption text-center mt-1">Beverage Image</div>
        </v-col>
        <v-col cols="12" sm="6">
          <v-img
            :src="submission?.shopImage"
            aspect-ratio="1"
            class="rounded-lg"
            cover
          >
            <template #placeholder>
              <v-skeleton-loader type="image" />
            </template>
          </v-img>
          <div class="text-caption text-center mt-1">Shop Image</div>
        </v-col>
      </v-row>

      <!-- Form Fields -->
      <v-form v-if="submission" ref="form">
        <v-row dense>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="submission.brandName"
              label="Brand Name"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="submission.packSize"
              label="Pack Size"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="submission.price"
              label="Price (IDR)"
              type="number"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="submission.reason"
              label="Reason"
              outlined
              rows="2"
              dense
            />
          </v-col>
        </v-row>
      </v-form>

      <!-- Action Buttons -->
      <v-row justify="end" class="mt-4">
        <v-btn
          color="green"
          class="mr-2"
          @click="updateStatus('approved')"
          :loading="loading"
         :disabled="loading || submission?.status === 'approved'"
        >
          Approve
        </v-btn>
        <v-btn
          color="red"
          @click="updateStatus('rejected')"
          :loading="loading"
          :disabled="loading || submission?.status === 'rejected'"
        >
          Reject
        </v-btn>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import RestResource from "../../../services/dataServiceMobileV2";
const service = new RestResource();

export default {
  data() {
    return {
      submission: null,
      loading: false,
    };
  },

  mounted() {
    this.getSubmissionData();
  },

  methods: {
    async getSubmissionData() {
      try {
        const response = await service.getBeverageSubmissionData({
          submissionId: this.$route.params.submissionId,
        });
        this.submission = response.data.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    async updateStatus(status) {
      this.loading = true;
      this.$setLoader();
      try {
        await service.updateBeverageStatus({
          submissionId: this.$route.params.submissionId,
          userId: this.$route.params.userId,
          status: status,
        });
        await this.getSubmissionData();
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
        this.$disableLoader();
      }
    },

    getStatusColor(status) {
      switch (status) {
        case "approved":
          return "green";
        case "rejected":
          return "red";
        case "pending":
          return "blue";
        default:
          return "grey";
      }
    },
  },
};
</script>

<style scoped>
.v-img {
  border-radius: 12px;
}
</style>
